import { alpha, createTheme } from '@mui/material/styles';

const primary = {
  main: '#7A9A01',
  dark: '#5f7700',
  light: '#9dbc22',
  contrastText: '#ffffff',
};

const theme = createTheme({
  palette: {
    primary,
    background: {
      default: '#f6f8ef',
      paper: '#ffffff',
    },
    text: {
      primary: '#1f2937',
      secondary: '#5f6b7a',
    },
  },
  shape: {
    borderRadius: 14,
  },
  typography: {
    fontFamily: ['Roboto', 'sans-serif'].join(','),
    h1: {
      fontSize: '2rem',
      fontWeight: 700,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    body1: {
      fontSize: '0.8rem',
    },
    body2: {
      fontSize: '0.7rem',
    },
    caption: {
      fontSize: '0.65rem',
    },
    button: {
      fontWeight: 700,
      textTransform: 'none',
      letterSpacing: 0,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 14,
          minHeight: 42,
          paddingInline: 18,
          lineHeight: 1.2,
        },
        sizeSmall: {
          minHeight: 34,
          paddingInline: 14,
          borderRadius: 12,
        },
        sizeLarge: {
          minHeight: 48,
          paddingInline: 22,
          borderRadius: 16,
        },
        containedPrimary: {
          backgroundColor: primary.main,
          border: `1px solid ${alpha(primary.dark, 0.28)}`,
          boxShadow: `0 10px 24px ${alpha(primary.dark, 0.22)}`,
          '&:hover': {
            backgroundColor: primary.dark,
            boxShadow: `0 12px 28px ${alpha(primary.dark, 0.28)}`,
          },
        },
        outlined: ({ theme }) => ({
          borderWidth: 1,
          backgroundColor: alpha(theme.palette.common.white, 0.78),
        }),
        outlinedPrimary: ({ theme }) => ({
          borderColor: alpha(theme.palette.primary.main, 0.28),
          color: theme.palette.text.primary,
          '&:hover': {
            borderColor: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.main, 0.06),
            boxShadow: `0 8px 18px ${alpha(theme.palette.primary.main, 0.12)}`,
          },
        }),
        text: ({ theme }) => ({
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
          },
        }),
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: 12,
          transition: 'background-color 160ms ease, color 160ms ease',
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
          },
        }),
      },
    },
  },
});

export default theme;
